import api from "../../../../api/axios";

const BASE = "/secaodebloqueio";
const DEFAULT_LIST_LIMIT = 5000;

export async function listarSecoesBloqueio({
  q = "",
  ativo,
  limit = DEFAULT_LIST_LIMIT,
  offset = 0,
} = {}) {
  const { data } = await api.get(`${BASE}/listar`, { params: { q, ativo, limit, offset } });
  return {
    rows: Array.isArray(data?.data) ?data.data : [],
    meta: data?.meta || { limit, offset },
  };
}

export async function listarSecoesBloqueioDistinct({
  q = "",
  ativo,
  limit = DEFAULT_LIST_LIMIT,
  offset = 0,
} = {}) {
  const { data } = await api.get(`${BASE}/listar-distinct`, {
    params: { q, ativo, limit, offset },
  });

  return {
    rows: Array.isArray(data?.data) ?data.data : [],
    meta: data?.meta || { limit, offset },
  };
}

export async function cadastrarSecaoBloqueio(payload) {
  const { data } = await api.post(`${BASE}/cadastrar`, payload);
  return data;
}

export async function editarSecaoBloqueio(id, payload) {
  const { data } = await api.put(`${BASE}/editar/${id}`, payload);
  return data;
}

export async function alterarStatusSecaoBloqueio(id, ativo) {
  const { data } = await api.patch(`${BASE}/alterar-ativo/${id}`, {
    ativo: Number(ativo) ?1 : 0,
  });
  return data;
}

export async function excluirSecaoBloqueio(id) {
  const { data } = await api.delete(`${BASE}/excluir/${id}`);
  return data;
}
